// ABOUTME: Where the deep link in a pro-core status email lands: it reports the click in whichever arm the talent is
// ABOUTME: in, then hands them on to their application in the tracker arm and to the CV builder in control.
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'config/paths';
import { sendAtsStatusEmailLinkClicked } from 'modules/analytics';
import { useTrackerArm } from '../hooks';

/**
 * One link for both arms. pro-core sends the same URL to every talent it writes to, because the mail is written
 * before anyone asks Unleash anything; the arm is resolved here, where the proxy has already answered for this
 * talent. A control talent therefore never reaches the applications route, they reach the screen that is theirs
 * today, and the click still counts on both sides of the experiment.
 *
 * @param refId the application the mail was about, from the link
 */
export const StatusEmailLink = ({ refId }: { refId: string }) => {
  const navigate = useNavigate();
  const { variant, isTracker, isLoading } = useTrackerArm();
  const hasLanded = useRef(false);

  useEffect(() => {
    // The arm decides where the talent goes, so there is nothing honest to do until the proxy has answered.
    if (isLoading || hasLanded.current) return;
    hasLanded.current = true;

    const destination = isTracker
      ? `${PATHS.applications}/${refId}`
      : PATHS.cvBuilder;

    sendAtsStatusEmailLinkClicked({
      variant,
      destination,
      applicationRefId: refId
    });

    // Replaced, not pushed: going back from the application belongs in the mail, not in this hop.
    navigate(destination, { replace: true });
  }, [isLoading, isTracker, navigate, refId, variant]);

  return null;
};
